import axios from "axios"
import Cookie from "js-cookie"

export const admin_api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL + '/api/v1',
  timeout: 10000,
})

admin_api.interceptors.request.use((config) => {
  if (!!Cookie.get("ut_admin")) {
    let ut_admin = JSON.parse(Cookie.get("ut_admin"));
    let token = ut_admin["access_token"];
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config
})

admin_api.interceptors.response.use((response) => response, (err) => {
  if (!err.request?.responseURL?.match(/login/) && err?.response?.status === 401) {
    window.location = '/logout';
  } else return Promise.reject(err);
})